import { Col, Row } from 'antd';
import i18next from 'i18next';
import { FC, useCallback } from 'react';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import { AttrInternalType } from '~src/interfaces/attributes.types';
import { StoreI } from '~src/rootReducer';
import { routes } from '~src/routingConfig';
import { validatorMaxLength40, validatorRequired } from '~src/services/validators';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import CustomFormInput from '~src/shared/form/inputs/FormInput';
import { composeValidators } from '~src/shared/reactFinalForm/validators';
import { FieldType } from '~src/types';
import { AttributeAddI } from '~src/modules/attributes/interfaces';

import { ButtonWrapper, CreateAttrBtn } from './attributeAddForm.sc';

interface OwnProps extends Pick<RouteComponentProps<any>, 'history'> {
  t: i18next.TFunction;

  onSubmit(values: AttributeAddI): Promise<any>;
}

interface StateProps {
  loadingAdd: boolean;
  initialValues: { attributeType: AttrInternalType };
}

type Props = OwnProps & StateProps;

const AttributeAddForm: FC<Props> = (props) => {
  const mapValuesBeforeSubmit = (values: AttributeAddI) =>
    props.onSubmit({
      ...values,
      attributeName: values.attributeName.trim(),
      attributeType: props.initialValues.attributeType,
    });

  const renderField = useCallback(
    ({ autoFocus, input, label, meta: { touched, error }, labelKey }: FieldType) => (
      <CustomFormInput
        {...input}
        autoFocus={autoFocus}
        error={touched ? error : null}
        label={label}
        type={input.type}
        labelKey={labelKey}
      />
    ),
    [],
  );

  const goBack = () => {
    props.history.push(routes.company.attributes);
  };

  const { t, loadingAdd } = props;
  const attributeNamePlaceholder = t('x.attributes.add.input.placeholder.attribute_name');
  return (
    <Form onSubmit={mapValuesBeforeSubmit}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} style={{ marginBottom: '75px' }} noValidate>
          <Row>
            <Col span={24} style={{ marginTop: '60px' }}>
              <Field
                autoFocus
                name="attributeName"
                label={attributeNamePlaceholder}
                type="text"
                children={renderField}
                validate={composeValidators([validatorRequired, validatorMaxLength40])}
                labelKey="x.attributes.add.input.placeholder.attribute_name"
              />
            </Col>
          </Row>
          <ButtonWrapper>
            <SecondaryButton type="button" onClick={goBack}>
              <span data-translation="x.attributes.add.button_cancel">
                {t('x.attributes.add.button_cancel')}
              </span>
            </SecondaryButton>
            <CreateAttrBtn isLoading={loadingAdd}>
              <span data-translation="x.attributes.add.button_create">
                {t('x.attributes.add.button_create')}
              </span>
            </CreateAttrBtn>
          </ButtonWrapper>
        </form>
      )}
    </Form>
  );
};

const mapStateToProps = (state: StoreI): StateProps => {
  return {
    loadingAdd: state.attributes.loadingAdd,
    initialValues: {
      attributeType: AttrInternalType.Option,
    },
  };
};

const AttributeAddFormC = connect(mapStateToProps)(AttributeAddForm);

export default AttributeAddFormC;
